import { CardSolicitationItem, CardSolicitationItems } from "../card-solicitation";

export class SolicitationRequest {
    constructor(assignorGuid?: string) {
        this.assignorGuid = assignorGuid;
     }

    assignorGuid: string;
}

export class SolicitCardRequest {
    constructor() { }

    assignorGuid: string;
    managerGuid: string;
    cardSolicitationItems: CardSolicitationItems[]
}

export class UpdateSolicitationRequest {
    constructor() {}

    assignorGuid: string;
    managerGuid: string;
    solicitationId: number;
    statusId: number = 5;
    reason: string;
}

export class UpdateSolicitationItemRequest {
    constructor() {}

    assignorGuid: string;
    managerGuid: string;
    solicitationId: number;
    cardSolicitationItem: CardSolicitationItem;
}

